import Reflux from 'reflux';
import EventFSObjectData from 'shared/data/EventFileSystemObject';
import readOnlyHelper from 'flux/helpers/readOnlyHelper';
import { DisplayTypes } from 'shared/constants/FlowConstants';

let async = { asyncResult: true };
const asyncReadOnlyCfg = readOnlyHelper.actionConfigFactory(async);
const readOnlyCfg = readOnlyHelper.actionConfigFactory();

let EventFolderListActions = Reflux.createActions({
  populate: {},
  populateDisplayType: {},
  getAllDisplayTypes: async,
  fetchParent: async,
  fetchParentPath: async,
  fetch: async,
  fetchDisplayType: async,
  setFolder: {},
  setFolderPath: {},
  startEditingObject: readOnlyCfg,
  cancelEditingObject: {},
  toggleSortField: {},
  softDeleteObject: async,
  softDeleteObjects: async,
  archiveObject: asyncReadOnlyCfg,
  archiveObjects: async,
  selectObject: {},
  addObjectToSelection: {},
  moveSelectionUp: {},
  moveSelectionDown: {},
  rangeSelectObject: {},
  rangeSelectionUp: {},
  rangeSelectionDown: {},
  clearSelection: {},
});

//EventFolderListActions.populate.listenAndPromise(EventFSObjectData.getFolderChildren);
EventFolderListActions.fetchParent.listenAndPromise(EventFSObjectData.get);
EventFolderListActions.fetchParentPath.listenAndPromise(
  EventFSObjectData.getByPath,
);
EventFolderListActions.fetch.listenAndPromise(
  EventFSObjectData.getFolderChildren,
);
EventFolderListActions.fetchDisplayType.listenAndPromise(
  EventFSObjectData.getByDisplayType,
);
EventFolderListActions.archiveObject.listenAndPromise(
  EventFSObjectData.archive,
);
EventFolderListActions.archiveObjects.listenAndPromise(
  (teamId, eventId, objectIds) => {
    return Promise.all(
      objectIds.map((objId) =>
        EventFSObjectData.archive(teamId, eventId, objId),
      ),
    );
  },
);

EventFolderListActions.getAllDisplayTypes.listenAndPromise(
  (teamId, eventId) => {
    const { show, schedule, list } = DisplayTypes;
    return Promise.all([
      EventFSObjectData.getByDisplayType(teamId, eventId, show, 1, 500),
      EventFSObjectData.getByDisplayType(teamId, eventId, schedule, 1, 500),
      EventFSObjectData.getByDisplayType(teamId, eventId, list, 1, 500),
    ]);
  },
);
EventFolderListActions.softDeleteObject.listenAndPromise(
  EventFSObjectData.softDelete,
);
//EventFolderListActions.populateDisplayType.listenAndPromise(EventFSObjectData.getByDisplayType);

export default EventFolderListActions;
